import { component } from 'picoapp';

export default component((node: HTMLFormElement) => {
  const button = node.querySelector<HTMLButtonElement>('[data-submit]');
  const readyIcon = button.querySelector<HTMLElement>('[data-icon="ready"]');
  const addedIcon = button.querySelector<HTMLElement>('[data-icon="added"]');

  node.addEventListener('submit', async (event) => {
    event.preventDefault();

    const target = event.target as HTMLFormElement;

    button.disabled = true;
    readyIcon.classList.remove('top-1/2', '-translate-y-1/2');
    readyIcon.classList.add('top-full');
    addedIcon.classList.remove('top-full');
    addedIcon.classList.add('top-1/2', '-translate-y-1/2');

    await fetch(`${target.action}.js`, {
      method: target.method,
      body: new FormData(target),
    });

    const evt: CustomEvent = new CustomEvent('cart:product:added');
    document.dispatchEvent(evt);

    setTimeout(() => {
      button.disabled = false;
      addedIcon.classList.remove('top-1/2', '-translate-y-1/2');
      addedIcon.classList.add('top-full');
      readyIcon.classList.remove('top-full');
      readyIcon.classList.add('top-1/2', '-translate-y-1/2');
    }, 2000);
  });
});
